/**
 * Delad mediapool för SEO-landningssidor.
 * Återanvänder samma stills och YouTube-videor som Prime-tjänsterna,
 * så alla SEO-sidor (städer, branscher, format) får produktionsbevis
 * utan att vi behöver redigera varje route.
 */

export const defaultLandingStills: string[] = [
  "/prime-stills/garageportexperten-fenny-1.jpg",
  "/prime-stills/bolt-fenny-1.jpg",
  "/prime-stills/also-fenny-1.jpg",
  "/prime-stills/fenny-reklam-film-1.jpg",
  "/prime-stills/raaaabaatar-fenny-1.jpg",
  "/prime-stills/pricka-fenny-1.jpg",
  "/prime-stills/elektronikbranschen-fenny-1.jpg",
  "/prime-stills/garageportexperten-fenny-3.jpg",
  "/prime-stills/bolt-fenny-3.jpg",
  "/prime-stills/fenny-reklam-film-4.jpg",
  "/prime-stills/recompany-1.jpg",
  "/prime-stills/wimeck-fenny-1.jpg",
  "/prime-stills/raaaabaatar-fenny-3.jpg",
  "/prime-stills/garageportexperten-fenny-6.jpg",
];

export type LandingVideo = { videoId: string; title: string; client?: string };

export const defaultLandingVideos: LandingVideo[] = [
  { videoId: "O2zdqLfmM5E", title: "Garageportexperten Hemma", client: "Garageportexperten" },
  { videoId: "yvojXrb41Aw", title: "Bolt kampanj (20 sek)", client: "Bolt" },
  { videoId: "HwWGVOl6dtg", title: "ALSO Huawei Energy Solution", client: "ALSO / Huawei" },
  { videoId: "GPm8ubB79DM", title: "Årets Pryl 2026", client: "Elektronikbranschen" },
  { videoId: "BzHML38R2bs", title: "Pricka — reklam", client: "Pricka" },
  { videoId: "WONrMkeJuik", title: "Wimeck Detailing", client: "Wimeck" },
  { videoId: "9iiyNS4yNzA", title: "Maria på Garageportexperten", client: "Garageportexperten" },
  { videoId: "oXoAyTogRrA", title: "Svensk Radonförening — podden", client: "Svensk Radonförening" },
];
